var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar"},[_c('SfLink',{attrs:{"link":"/shipping-policy"}},[_vm._v("Free shipping on most orders over $100!*")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }